function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// Material imports
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import CancelIcon from "@mui/icons-material/Cancel";
function NoOptionsMessage(props) {
  return /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "body1",
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}
const InputComponent = /*#__PURE__*/React.forwardRef(({
  ...rest
}, ref) => /*#__PURE__*/React.createElement("div", _extends({
  ref: rest.inputRef
}, rest)));
InputComponent.displayName = "InputComponent";
function Control(props) {
  let inputClass = props.selectProps.classes.input;
  if (!props.isMulti) {
    inputClass = `${inputClass} ${props.selectProps.classes.singleSelectInput}`;
  }
  if (!props.isSearchable) {
    inputClass = `${inputClass} ${props.selectProps.classes.dropdownCursor}`;
  }
  return /*#__PURE__*/React.createElement(TextField, _extends({
    fullWidth: true,
    variant: props.selectProps.error ? "outlined" : "standard",
    InputProps: {
      inputComponent: InputComponent,
      disableUnderline: true,
      inputProps: {
        className: inputClass,
        children: props.children,
        ...props.innerProps
      },
      classes: {
        root: props.selectProps.classes.border
      },
      error: props.selectProps.error
    },
    inputRef: props.innerRef
  }, props.selectProps.textFieldProps));
}
function Option(props) {
  const children = props.data && props.data.renderMenuItem ? props.data.renderMenuItem(props.data) : props.children;
  return /*#__PURE__*/React.createElement(MenuItem, _extends({
    ref: props.innerRef,
    selected: props.isFocused,
    component: "div",
    style: {
      fontWeight: props.isSelected ? 500 : 400,
      whiteSpace: "normal"
    }
  }, props.innerProps), children);
}
function Placeholder(props) {
  if (props.selectProps.isDisabled && !props.selectProps.isLoading) {
    return /*#__PURE__*/React.createElement(Typography, _extends({
      variant: "body1",
      color: "textSecondary",
      className: `${props.selectProps.classes.placeholder} ${props.selectProps.classes.disabled}`
    }, props.innerProps), props.selectProps.disabledMessage);
  }
  return /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "body1",
    color: "textSecondary",
    className: props.selectProps.classes.placeholder
  }, props.innerProps), props.selectProps.isLoading ? props.selectProps.loadingMessage() : props.children);
}
function SingleValue(props) {
  const children = props.data && props.data.renderMenuItem ? props.data.renderMenuItem(props.data) : props.children;
  let singleValueClass = props.selectProps.classes.singleValue;
  if (props.selectProps.isDisabled) {
    singleValueClass = `${singleValueClass} ${props.selectProps.classes.disabled}`;
  }
  return /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "body1",
    className: singleValueClass
  }, props.innerProps), children);
}
function ValueContainer(props) {
  if (props.isMulti) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.selectProps.classes.multiValueContainer
    }, props.children);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}
function MultiValue(props) {
  return /*#__PURE__*/React.createElement(Chip, {
    tabIndex: -1,
    label: props.children,
    className: classNames(props.selectProps.classes.chip, {
      [props.selectProps.classes.chipFocused]: props.isFocused
    }),
    classes: {
      label: props.selectProps.classes.chipLabel
    },
    onDelete: props.removeProps.onClick,
    deleteIcon: /*#__PURE__*/React.createElement(CancelIcon, props.removeProps)
  });
}
function Menu(props) {
  let paperClass = props.selectProps.classes.paper;
  if (props.selectProps.isFixedPosition) {
    paperClass = `${paperClass} ${props.selectProps.classes.paperFixed}`;
  } else {
    paperClass = `${paperClass} ${props.selectProps.classes.paperAbs}`;
  }
  return /*#__PURE__*/React.createElement(Paper, _extends({
    square: true,
    className: paperClass,
    style: {
      minWidth: props.selectProps.minMenuWidth,
      zIndex: 2000
    }
  }, props.innerProps), props.children);
}
const commonPropTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  selectProps: PropTypes.object,
  innerProps: PropTypes.object,
  isSelected: PropTypes.bool,
  isFocused: PropTypes.bool,
  innerRef: PropTypes.func,
  removeProps: PropTypes.object,
  inputRef: PropTypes.func,
  isMulti: PropTypes.bool,
  data: PropTypes.object,
  background: PropTypes.string,
  isSearchable: PropTypes.bool,
  theme: PropTypes.object,
  isFixedPosition: PropTypes.bool
};
Control.propTypes = commonPropTypes;
Menu.propTypes = commonPropTypes;
MultiValue.propTypes = commonPropTypes;
NoOptionsMessage.propTypes = commonPropTypes;
Option.propTypes = commonPropTypes;
Placeholder.propTypes = commonPropTypes;
SingleValue.propTypes = commonPropTypes;
ValueContainer.propTypes = commonPropTypes;
InputComponent.propTypes = commonPropTypes;
export const COMPONENTS = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer
};